import React from 'react';
import PropTypes from 'prop-types';

import Step from './Step';
import { StepperWrapper } from './Stepper.styled';

const Stepper = ({ steps, className }) => (
  <StepperWrapper className={className}>
    {steps.map(({ title, isActive, isClickable, onClick }) => (
      <Step
        isActive={isActive}
        isClickable={isClickable}
        key={title}
        title={title}
        onStepClick={onClick}
      />
    ))}
  </StepperWrapper>
);

Stepper.defaultProps = {
  className: '',
};

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
      isClickable: PropTypes.bool.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
};

export default Stepper;
